import React, { Component } from "react";
import { Spring } from 'react-spring/renderprops';
import { config } from 'react-spring';
import { Popover, List } from 'antd';

import './Db365Logo.css';
class Db365Logo extends Component {

	state = {
		hover: false,
	}

	styleLogoLarge = {
		marginLeft: 13,
		marginRight: 10,
		marginBottom: 0,
		marginTop: 15,
	}

	onMouseOverLogo = () => {
		this.setState({ hover: !this.state.hover })
	}

	render() {
		return (
			<div style={{ cursor: 'pointer' }} >
				{this.props.large &&
					<div style={this.styleLogoLarge} >
						<Spring config={{ ...config.slow, clamp: true }}
							from={{ opacity: 0 }}
							to={{ opacity: 1 }}>
							{props =>
								<Popover placement="bottom" content={<List style={{width: 270}}
									itemLayout="horizontal"
									dataSource={this.props.menuItems}
									renderItem={item => (
										<List.Item>
											<List.Item.Meta
												title={<a style={{display:'block'}} href={item.db365MenuUrl}> <img alt="logo" src='/img/DB-blue.svg' style={{width: 20, paddingBottom: 5}} /> -  <b>{item.name}</b></a>}
											/>
										</List.Item>
									)}
								/>} trigger="click">
									<svg style={props}
										xmlns="http://www.w3.org/2000/svg"
										width="144" height="50"
										x="0"
										y="0"
										enableBackground="new 0 0 841.9 595.3"
										version="1.1"
										viewBox="135 240 550 110"
										xmlSpace="preserve"
									>
										<path
											d="M600.6 212.2c-1.4 2.6-2.8 5.2-4.2 7.7l-12 21.3c-4 7-7.9 14-11.9 21-.5 1-1.1 1.9-1.6 3 10.1 9.3 17.2 20.5 21.2 33.3 2.7-1.5 5.2-3.1 7.9-4.3 4.9-2.2 10.1-2.6 15.4-1.7 6.7 1.2 12.3 4.2 16.7 9.4 4.5 5.3 6.9 11.3 6.9 18.3 0 8.8-3.3 16-9.8 21.8-6.3 5.5-13.8 7.9-22 6.7-11.7-1.7-19.8-8.3-23.5-19.6-.9-2.7-1.3-5.8-1.4-8.7-.1-4.1-.5-8.1-1.3-11.9-.1-.4-.2-.9-.3-1.3-.3-1.5-.7-3-1.2-4.5-.1-.4-.2-.8-.4-1.2-.5-1.5-1.1-3.1-1.7-4.6-.1-.3-.2-.6-.4-.9-.6-1.5-1.4-3-2.1-4.4-.2-.3-.3-.6-.5-.9-.7-1.2-1.4-2.4-2.2-3.6-.3-.5-.6-1-1-1.5-.3-.4-.7-.9-1-1.3-2-2.8-4.3-5.5-6.8-8-.2-.2-.5-.4-.8-.7-1.3-1.2-2.6-2.4-4-3.5-.4-.4-.9-.7-1.4-1-1.3-1-2.6-1.9-4-2.8-.3-.2-.7-.4-1-.6-1.6-1-3.3-1.9-5.1-2.8l-.1-.1c-.1 0-.1-.1-.2-.1-6.6-3.2-13.7-5.3-21.3-6 8.8-15.6 17.5-31.1 26.3-46.6h-41.6c-6.9 12.2-13.7 24.4-20.6 36.5-2.9 5.1-5.8 10.3-8.7 15.4-.2.4-4.1 6.5-7.6 12.4-3.2-3.2-6.7-6-10.6-8.4-1.5-.9-3-1.8-4.6-2.8 3.5-6.1 6.8-12 10.2-17.9 4.6-8.1 9.2-16.3 13.8-24.5l6-10.8H345.2c13.7.6 24.6 3.9 32.3 9.8 2.8 1.9 5.3 4.1 7.4 6.6v11.3c0 .3.1.7.1 1.2h45.3c-9.7 17.2-19.2 34-28.8 51.1h9.4c5.4 0 10.7.2 16.1-.1 3.2-.2 6.4 0 9.5.7 4.3 1 8.3 2.9 11.7 5.9 5.9 5.1 9.4 11.4 10.1 19 0 .9-.1 1.9-.1 2.8 0 34.2 27.8 62 62 62 11.4 0 22-3.1 31.2-8.5 1.4-.8 4.3-2.7 4.2-2.7 3.6-2.5 6.9-5.4 9.9-8.6 5 5.3 10.8 9.8 17.5 13.1 7.5 3.7 15.5 5.8 23.9 6.4 15.9 1.1 30-3.6 42.4-13.3 8-6.2 13.9-14.2 18-23.5 4-8.9 5.6-18.2 5.1-28-.6-14.1-5.6-26.4-14.7-37.2-5.6-6.6-12.3-11.7-20-15.5-6-2.9-12.3-4.9-19-5.6-.8-.1-1.6-.3-2.6-.4.9-1.7 1.8-3.4 2.8-5.1 2.2-3.8 4.4-7.6 6.5-11.4.6-1 1.2-1.3 2.3-1.3h44.9v-1.8-25.2c0-.6.1-1.3.1-1.9-24.1.4-48.1.4-72.1.4zm-87.3 80.9c3.8-.9 7.6-1.1 11.6-.5 5.8.9 10.8 3.4 15 7.4 2.5 2.3 4.4 4.9 5.9 7.8.1.2.2.4.3.5.3.6.5 1.1.8 1.7.1.2.1.3.2.5.8 2.2 1.4 4.5 1.6 7l.3 3.9c-.2 8.4-4.1 15.9-10.1 21-.5.4-.8.6-1.1.8-4.1 3.2-8.8 5.1-14 5.6-8.8.9-16.6-1.7-23-7.9-5.7-5.5-8.6-12.3-8.6-20.2 0-1.2-.1-2.4-.1-3.7 1.5-11.2 11.2-20.8 21.2-23.9z"
											className="logo-365"
										></path>
										<path
											d="M375.3 288.5c11.9-7.4 18.5-19.1 18.5-33.1 0-5.2-.7-10-2.1-14.4-2.5-8-7.3-14.5-14.1-19-7.7-5.9-18.6-9.1-32.3-9.8-1.6-.1-3.2-.1-4.8-.1H286v42.8c-2.4-5.1-5.3-9.8-8.8-14.2-18.6-25.2-45.7-28.6-69.8-28.6h-52.7v164.7h55.1c37.5 0 63.8-14.8 76.2-41.6v41.6h51.2c23.8 0 33.9-1.7 47-11.6 11.3-7.8 18-21.8 18-37.4 0-11-3.6-30.3-26.9-39.3zm-163.8 57.3h-21.9V243.1h22.2c16.4 0 28.4 5.2 36.7 15.8 6.9 9.1 10.7 21.8 10.7 35.8-.1 19.1-6.3 51.1-47.7 51.1zm109.4-102.7h16.9c6.2 0 10.7.7 14 2.3 2 .8 8.3 4.3 8.3 14.3 0 7.4-2.7 12.2-8.5 15.2-3.3 1.4-7.9 2.1-13.6 2.1h-17.1v-33.9zm36.7 100.4c-4.7 2.1-10.3 2.3-14.7 2.3H321v-39h20.8c5.6 0 11 0 16 2.1 4.9 2.1 10.7 6.8 10.7 17 0 8.6-3.6 14.4-10.9 17.6z"
											className="logo-db"
										></path>
										<path
											d="M448.6 342.4c3.4 10.9 9 20.5 16.8 29.2-3.4 1.9-6.4 3.9-9.7 5.3-4 1.7-8.2 3-12.4 4.1-6 1.5-12.1 2-18.3 1.4-8-.7-15.5-2.9-22.7-6.5-7.8-3.8-14.4-9.2-20-15.8-4.4-5.3-7.9-11.2-10.3-17.6-2.6-7-3.9-14.3-3.9-21.8 0-.1 33.5-.2 33.5-.1 0 8.8 3.7 16.4 10.3 21.9 6.1 5.2 13.4 7.2 21.3 6.3 5.1-.5 9.8-2.5 14-5.6.2-.2.4-.4.7-.5.2-.1.4-.2.7-.3z"
											className="logo-365"
										></path>
									</svg></Popover>}
									</Spring>
					</div>
				}
				{!this.props.large &&
					<div onMouseEnter={this.onMouseOverLogo} onMouseLeave={this.onMouseOverLogo} >
						<Popover placement="bottom" content={<List 	 style={{width: 270}}
									itemLayout="horizontal"
									dataSource={this.props.menuItems}
									renderItem={item => (
										<List.Item>
											<List.Item.Meta
												title={<a style={{display:'block'}} href={item.db365MenuUrl}> <img alt="logo" src='/img/DB-blue.svg' style={{width: 20, paddingBottom: 5}} /> -  <b>{item.name}</b></a>}
											/>
										</List.Item>
									)}
								/>} trigger="click">
						<svg
							version="1.1"
							xmlns="http://www.w3.org/2000/svg"
							x="0px"
							y="0px"
							viewBox="0 0 40 40"
							enableBackground="new 0 0 40 40"
							xmlSpace="preserve"
						>
							{this.state.hover &&
								<Spring config={{ ...config.slow, clamp: true }}
									from={{ opacity: 0 }}
									to={{ opacity: 1 }}>
									{props =>
										<g style={props}>
											<circle className="logo-db" cx="13.5" cy="12.5" r="1.5" />
											<circle className="logo-db" cx="13.5" cy="18.5" r="1.5" />
											<circle className="logo-db" cx="13.5" cy="24.5" r="1.5" />
											<circle className="logo-db" cx="19.5" cy="12.5" r="1.5" />
											<circle className="logo-db" cx="19.5" cy="18.5" r="1.5" />
											<circle className="logo-db" cx="19.5" cy="24.5" r="1.5" />
											<circle className="logo-db" cx="25.5" cy="12.5" r="1.5" />
											<circle className="logo-db" cx="25.5" cy="18.5" r="1.5" />
											<circle className="logo-db" cx="25.5" cy="24.5" r="1.5" />
										</g>}
								</Spring>
							}
							{!this.state.hover &&
								<Spring config={{ ...config.slow, clamp: true }}
									from={{ opacity: 0 }}
									to={{ opacity: 1 }}>
									{props =>
										<path style={props} d="M27.5,18.1c1-0.6,1.5-1.5,1.5-2.7c0-0.4-0.1-0.8-0.2-1.2c-0.2-0.6-0.6-1.2-1.1-1.5c-0.6-0.5-1.5-0.7-2.6-0.8
												c-0.1,0-0.3,0-0.4,0h-4.4v3.4c-0.2-0.4-0.4-0.8-0.7-1.1C18.1,12.2,16,12,14,12H9.8v13.2h4.4c3,0,5.1-1.2,6.1-3.3v3.3h4.1
												c1.9,0,2.7-0.1,3.8-0.9c0.9-0.6,1.4-1.7,1.4-3C29.7,20.4,29.4,18.8,27.5,18.1z M14.4,22.7h-1.8v-8.2h1.8c1.3,0,2.3,0.4,2.9,1.3
												c0.6,0.7,0.9,1.7,0.9,2.9C18.2,20.1,17.7,22.7,14.4,22.7z M23.1,14.4h1.4c0.5,0,0.9,0.1,1.1,0.2c0.2,0.1,0.7,0.3,0.7,1.1
												c0,0.6-0.2,1-0.7,1.2c-0.3,0.1-0.6,0.2-1.1,0.2h-1.4V14.4z M26.1,22.5c-0.4,0.2-0.8,0.2-1.2,0.2h-1.8v-3.1h1.7c0.5,0,0.9,0,1.3,0.2
												c0.4,0.2,0.9,0.5,0.9,1.4C27,21.8,26.7,22.2,26.1,22.5z"
											className="logo-db"></path>}
								</Spring>
							}

						</svg></Popover>
					</div>
				}
			</div>
		);
	}
}

export default Db365Logo;